<template>
  <a-skeleton active :loading="loading" :title="false" :paragraph="{rows: 8, width: 800}">
    <div>
      <a-form :layout="formLayout" :form="form">
        <a-text-field
          varName="given_name"
          varLabel="Given Name"
          :varRequired="true"
          :varInitial="user.given_name"
          :size="size"
          :formLayout="formLayout"
        />
        <a-text-field
          varName="family_name"
          varLabel="Family Name"
          :varRequired="true"
          :varInitial="user.family_name"
          :size="size"
          :formLayout="formLayout"
        />
        <a-text-misc-field
          varName="email"
          varLabel="Email"
          :varRequired="true"
          :varInitial="user.email"
          :size="size"
          :formLayout="formLayout"
          varType="email"
          :disabled="true"
        />
        <a-phone-field
          varName="phone"
          varLabel="Phone"
          :varRequired="true"
          :varInitial="user.phone"
          :size="size"
          :formLayout="formLayout"
          :disabled="false"
        />
        <a-auto-complete-select
          varName="zoneinfo"
          varLabel="Timezone"
          :varRequired="true"
          :varInitial="user.zoneinfo"
          :formLayout="formLayout"
          :size="size"
          :data="dataSource"
        />
        <a-switch-field
          varName="mfa_enabled"
          varLabel="Multi-factor enabled"
          :varRequired="true"
          :varInitial="user.mfa_enabled"
          :formLayout="formLayout"
          :size="size"
        />
        <a-submit-button
          @submit="handleSubmit"
          :formLayout="formLayout"
          btn_text="Update details"
          styled="margin-top:0.5em; padding-left:4em;"
        />
      </a-form>
    </div>
  </a-skeleton>
</template>

<script>
import moment from "moment-timezone";
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],

  data() {
    return {
      loading: true,
      size: "large",
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      dataSource: moment.tz.names()
    };
  },
  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      await this.$store.dispatch("axioms/getItem", {
        endpoint: "users",
        uuid: this.$auth.session.id_payload.sub
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  },
  computed: {
    user() {
      return this.$store.state.axioms.users_item
        ? this.$store.state.axioms.users_item
        : {};
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            await this.$store.dispatch("axioms/patchItem", {
              endpoint: "users",
              uuid: this.$auth.session.id_payload.sub,
              data: values
            });
            await this.$notification.open({
                message: 'Settings updated!',
                description: 'Your profile settings are now updated.',
                icon: <a-icon type="check-circle" theme="filled" style="color: green" />
            });
          } catch (error) {
            console.error(error);
            form.setFields({
              phone: {
                value: values.phone,
                errors: [new Error(`${error.response.data.phone[0]}`)]
              }
            });
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    }
  }
};
</script>

<style>
</style>
